import background from '../../../assests/internship/intern-background-home.png'
import internship2 from '../../../assests/internship/internship-home2.png'
import internship5 from '../../../assests/internship/internship-home4.png'
import image1 from '../../../assests/internship/Live coaching.png'
import image2 from '../../../assests/internship/Beginner Level.png'
import image3 from '../../../assests/internship/Official Certification.png'
import image4 from '../../../assests/internship/One-on-one sessions.png'
import image5 from '../../../assests/internship/placement assistance.png'
import image6 from '../../../assests/internship/Top Industry Trainers.png'
import person2 from '../../../assests/internship/person2.png'
import '../internship.css'

import { FacebookFilled, InstagramOutlined, LinkedinFilled, WhatsAppOutlined, YoutubeOutlined } from '@ant-design/icons'

import about from "../../../assests/about_image.png";
import Header from '../../componets/header/header'
import Footer from '../../componets/footer/footer'
function InternshipCoding() {
    const handleDownload = () => {
        // const pdfUrl = new URL("../../assests/internship/MERN_Fullstack_Brochure.pdf", import.meta.url).href;
        const link = document.createElement("a");
        // link.href = pdfUrl;
        link.download = "MERN_Fullstack_Brochure.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const syllabusItems = [
        ['HTML5 & CSS3 Fundamentals', 'JavaScript ES6+ Features', 'React.js Components', 'JSX & Virtual DOM', 'State Management', 'React Hooks', 'Component Lifecycle', 'Event Handling', 'Responsive Design'],
        ['Node.js Fundamentals', 'Express.js Framework', 'RESTful API Development', 'MongoDB Database', 'Mongoose ODM', 'Authentication & Authorization', 'JWT Implementation', 'Middleware Development'],
        ['Full Stack Integration', 'Database Design', 'API Testing & Debugging', 'Version Control (Git)', 'Deployment Strategies', 'Cloud Hosting', 'Project Management', 'Industry Best Practices'],
    ];
    return (
        <div>
            <Header />
            <div >
                <section className="hero">
                    <div className="text_values">

                        <h1>Complete MERN Full Stack Development, Powered by Papa Digital Academy</h1>


                        <div className="social-icons">
                            <a href='https://www.facebook.com/papadigitalsolution' target="_blank" rel="noopener noreferrer">
                                <FacebookFilled style={{ color: "white" }} />
                            </a>
                            <a href='https://www.instagram.com/papaekmpapa/' target="_blank" rel="noopener noreferrer">
                                <InstagramOutlined className="fab fa-instagram" style={{ color: "white" }} />
                            </a>
                            <a href='https://www.youtube.com/@Papadigitalsolution' target="_blank" rel="noopener noreferrer">
                                <YoutubeOutlined className="fab fa-youtube" style={{ color: "white" }} />
                            </a>
                            <a href='https://www.linkedin.com/company/papa-digital-solution/posts/?feedView=all' target="_blank" rel="noopener noreferrer">
                                <LinkedinFilled className="fab fa-linkedin-in" style={{ color: "white" }} />
                            </a>
                            <a href='https://wa.me/919562121117' target="_blank" rel="noopener noreferrer">
                                <WhatsAppOutlined className="fab fa-whatsapp" style={{ color: "white" }} />
                            </a>
                        </div>
                    </div>

                    <img src={background} alt="Group of Students" style={{
                        position: 'absolute',
                        bottom: 0,
                        maxWidth: '100%',
                        height: 'auto',
                        zIndex: 2,
                    }} />


                </section>
                <section className="overlay-section">
                    <img src={internship2} alt="MERN Stack Development" className="background-image" />
                    <div className="overlay-content">
                        <h2>Best Online MERN Full Stack Development Courses in India</h2>
                        <p>At Papa Digital Academy, we help aspiring developers transform their coding dreams into professional web development careers through comprehensive
                            MERN stack training. Our live online courses are
                            designed to give you hands-on experience with real-world
                            applications used by top tech companies and startups.

                            Many of our students have seen fast-track growth—whether landing their first developer job,
                            switching careers from other fields, or building their own web applications. Our curriculum covers the complete MERN stack
                            (MongoDB, Express.js, React.js, Node.js), helping
                            learners gain the full-stack skills that employers are actively seeking.
                        </p>
                        <p>
                            What makes Papa Digital Academy stand out is the practical approach we bring to your
                            learning journey. As your coding skills improve, so do your job opportunities and earning potential.
                            Our learners often see significant salary growth after completing
                            the program, making their investment both smart and career-transforming.

                            Join Papa Digital Academy and take the next big step toward a successful, future-proof career in full-stack web development.
                        </p>
                    </div>
                </section>
                <section className="course-audience-section">
                    <h2>WHO SHOULD ATTEND THE COURSE</h2>
                    <div className="audience-cards-container">
                        <div className="audience-card">
                            <span className="card-number">1</span>
                            <h3>For Students & Graduates</h3>
                            <h4>Build Your Tech Career!</h4>
                            <p>
                                Are you ready to become a skilled Full Stack Developer? Dive into our comprehensive
                                MERN stack courses designed to launch you into the tech industry with the most in-demand programming skills.
                                Let's turn your coding potential into a successful development career!
                            </p>
                        </div>

                        <div className="audience-card">
                            <span className="card-number">2</span>
                            <h3>For Career Switchers</h3>
                            <h4>Transform Your Professional Path!</h4>
                            <p>
                                Ready to switch to a high-demand tech career? Our structured full-stack development program is perfect for
                                professionals from any background to gain coding expertise at a manageable pace. Empower yourself to enter the tech world with confidence
                                and cutting-edge development skills!
                            </p>
                        </div>

                        <div className="audience-card">
                            <span className="card-number">3</span>
                            <h3>For Working Professionals</h3>
                            <h4>Level Up Your Tech Skills!</h4>
                            <p>
                                Want to add full-stack development to your skill set? It's time to enhance your career prospects with our
                                comprehensive MERN stack training. Boost your resume with modern web development skills and unlock new opportunities
                                in the ever-growing tech industry!
                            </p>
                        </div>

                        <div className="audience-card">
                            <span className="card-number">4</span>
                            <h3>For Entrepreneurs</h3>
                            <h4>Build Your Own Web Solutions!</h4>
                            <p>
                                Ready to bring your business ideas to life online? Learn how to develop complete web applications, e-commerce platforms,
                                and custom software solutions that can significantly boost your business capabilities. Join us and gain the technical skills
                                to build and scale your digital ventures!
                            </p>
                        </div>
                        <div className="audience-card">
                            <span className="card-number">5</span>
                            <h3>For Coding Enthusiasts</h3>
                            <h4>Master Modern Web Development!</h4>
                            <p>
                                Passionate about programming and web technologies? Our courses provide comprehensive training in the complete MERN stack
                                to turn your coding interest into professional expertise. Whether you're a beginner or have some coding background,
                                join us to master full-stack web development!
                            </p>
                        </div>
                        <div className="audience-card">
                            <span className="card-number">6</span>
                            <h3>For Freelancers & Consultants</h3>
                            <h4>Expand Your Service Offerings!</h4>
                            <p>
                                Already working independently? Add full-stack development to your skillset and significantly expand your service offerings!
                                Learn to build complete web applications from scratch, increase your project value, and command higher rates as a
                                full-stack developer. Unlock the potential of end-to-end web development services!
                            </p>
                        </div>
                    </div>
                </section>
                <div className="about-section-wrapper">
                    <div className="about-left">
                        <div className="internship-images">
                            <img src={person2} alt="internship-home" />
                        </div>

                    </div>


                    <div className="about-right">
                        <h6 className="about-subtitle">About Us</h6>
                        <h2 className="about-title">
                            WHO WE ARE
                        </h2>
                        <div className="about-summary">

                            <div className="about-description">
                                <p>
                                    At Papa Digital Academy, we are more than just a coding bootcamp - we are your technical
                                    partners in building a successful development career.
                                    Our mission is to empower aspiring developers and tech professionals by providing comprehensive, hands-on full-stack development
                                    education that drives technical excellence, problem-solving skills, and career advancement.
                                </p>
                                <p>
                                    Founded on the principles of practical learning, innovation, and student success, we pride
                                    ourselves on delivering exceptional web development education through industry-standard technologies and expert
                                    mentorship. Our academy is led by senior developers with more than 5+ years
                                    of experience in full-stack development and modern web technologies. With such extensive technical expertise, Papa
                                    Digital Academy aims to become the premier destination for students, career switchers, and
                                    professionals looking to master MERN stack development and build successful tech careers.
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="internship-offer-section">
                    <div className="internship-home3">
                        <div className="internship-images">
                            <img src={internship5} alt="internship-home" />
                        </div>

                        <div className="internship-texts">
                            <h2 className="about-title">WHAT WE OFFER</h2>
                            <div className="about-description">
                                <p>
                                    At Papa Digital Academy, we go beyond teaching syntax—you'll receive technical mentorship, code reviews,
                                    and career guidance from experienced full-stack developers who've built scalable applications. Our goal is to elevate
                                    technical talent by fostering a culture of clean code, best practices, and continuous learning.
                                    Here's how we do it:
                                </p>
                                <ul>
                                    <li>
                                        <strong>Real Projects & Portfolio Development:</strong> Our hands-on approach lets you learn by building.
                                        You'll develop complete web applications, creating an impressive GitHub portfolio that showcases your full-stack capabilities.
                                    </li>
                                    <li>
                                        <strong>Industry Standards & Best Practices:</strong> We emphasize clean code, proper architecture, and professional development workflows,
                                        ensuring our students develop both technical skills and the professional mindset needed for enterprise-level development.
                                    </li>
                                    <li>
                                        <strong>Expert Code Mentorship & Technical Guidance:</strong> You won't just watch tutorials—you'll be mentored by senior developers with
                                        extensive industry experience, providing personalized code reviews and technical direction throughout your learning journey.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="timings-section">
                    <h2 className="about-title">TIMINGS</h2>
                    <div className="timings-top">
                        <div className="timing-box">
                            <div className="timing-icon">💻</div>
                            <p><strong>MON–FRI, 2 hours live coding sessions.</strong></p>
                        </div>
                        <div className="timing-box">
                            <div className="timing-icon">💻</div>
                            <p><strong>4 Months of Intensive & Project-Based Development Training</strong></p>
                        </div>
                    </div>

                    <div className="timings-features">
                        {[
                            { icon: image1, text: 'Live coding sessions' },
                            { icon: image2, text: 'Beginner to Advanced' },
                            { icon: image3, text: 'Full Stack Certification' },
                            { icon: image4, text: 'One-on-one code reviews' },
                            { icon: image5, text: '100% job placement support' },
                            { icon: image6, text: 'Senior Developer Mentors' },
                        ].map((feature, index) => (
                            <div className="feature-item" key={index}>
                                <div className="feature-icon">
                                    <img src={feature.icon} alt={feature.text} style={{ width: 32, height: 32 }} />
                                </div>
                                <p>{feature.text}</p>
                            </div>
                        ))}
                    </div>

                </section>
                <div className="whatweoffer-container">
                    <div className="offer-image">
                        <img src={about} alt="What We Offer" />
                    </div>
                    <div className="offer-content">
                        <h2>Why Choose Our Full Stack Program?</h2>
                        <ul>
                            <li>Hands-on experience building complete web applications</li>
                            <li>Mentorship from experienced full-stack developers</li>
                            <li>Flexible learning schedule for working professionals</li>
                            <li>Comprehensive portfolio development and job placement support</li>
                            <p>At Papa Digital Academy, we believe in the power of practical coding education and the
                                importance of building real-world development skills. Join us, and let's code your way
                                to a successful tech career together!</p>
                        </ul>
                    </div>
                </div>
                <section className="syllabus-section">
                    <h2 className="about-title">CURRICULUM</h2>
                    <div className="syllabus-columns">
                        {syllabusItems.map((column, colIndex) => (
                            <ul className="syllabus-column" key={colIndex}>
                                {column.map((item, index) => (
                                    <li key={index} className="syllabus-item">
                                        <span className="syllabus-icon">💻</span>
                                        <span>{item}</span>
                                    </li>
                                ))}
                            </ul>
                        ))}
                    </div>
                </section>

                {/* <div>
                    <h3 onClick={handleDownload} className="blinking-text">
                        For More Info <span style={{ color: "#00aaff" }}>CLICK HERE</span>
                    </h3>
                </div> */}
            </div>
            <Footer />
        </div>
    )
}

export default InternshipCoding